module.exports = __webpack_public_path__ + "assets/images/pages/workshops/error-form.png?ac98ed7b";